import React from 'react';
import ReactDOM from 'react-dom'; 
import './assets/fomantic/dist/semantic.css';
import './index.css';
import "react-datepicker/dist/react-datepicker.css";

import App from './App';
import reportWebVitals from './reportWebVitals';
//import ThemeSwitcher from './ThemeSwitcher';


/*
ReactDOM.render(
  <ThemeSwitcher />, 
  document.getElementById('root')
);*/

ReactDOM.render(<App /> ,document.getElementById('root') );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
